import React from "react";
import logo from "../assets/logo.svg";
import backgroundImage from "../assets/top-first-circle.svg";
import useToggleModal from "../customHooks/useToggleModal";
import AboutUs from "./AboutUs";
import CustomModal from "./Modal2";
import { Link, useLocation } from "react-router-dom";

const NAVIGATION_TEXT = {
  ABOUT_US: "Om oss",
};

const Header: React.FC = () => {
  const { isModalOpen, onCloseModal, onOpenModal } = useToggleModal();
  const location = useLocation();

  const isTestPage = location.pathname === "/test";
  return (
    <>
      <header className="relative flex items-center py-[16px] px-[28px] md:px-[45px] md:py-[28px] lg:px-[90px] justify-between min-h-[5vh]">
        <img
          src={backgroundImage}
          alt="Background"
          className="absolute top-0 left-0 h-[125px] w-[125px] sm:h-[250px] sm:w-[250px] md:h-auto md:w-auto -z-10"
        />
        {isTestPage ? (
          <img
            src={logo}
            alt="Logo"
            className="h-[50px] w-[125px] z-10 relative"
          />
        ) : (
          <Link to="/">
            <img
              src={logo}
              alt="Logo"
              className="h-[50px] w-[125px] z-10 relative"
            />
          </Link>
        )}
        <nav className="z-10 relative">
          <button onClick={onOpenModal} className="text-white text-xl">
            {NAVIGATION_TEXT.ABOUT_US}
          </button>
        </nav>
      </header>
      <CustomModal isOpen={isModalOpen} onClose={onCloseModal} title={"Om oss"}>
        <AboutUs />
      </CustomModal>
    </>
  );
};

export default Header;
